import React, { FC } from 'react';
import { IconProps } from '.';

export const PaperPlaneIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg fill="none" {...sizing} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path stroke="currentColor" strokeWidth="1.5" d="M19.6 7.08 4 12l5.5 2 4.5 5 5.6-11.92Z" />
            <path
                fill="url(#004fe8cf)"
                d="M15.27 10.92a.5.5 0 1 0-.54-.84l.54.84Zm-.54-.84-5.5 3.5.54.84 5.5-3.5-.54-.84Z"
            />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth="1.5"
                d="M9 14v3.98c0 .2.24.33.4.2l2.1-1.68"
            />
            <defs>
                <linearGradient id="004fe8cf" x1="12" x2="14" y1="13" y2="10.5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
